import { useCallback } from 'react';

import { useQueryParamValue } from '#src/app/shared/hooks/location';
import type { ShareChannel } from '#src/app/shared/hooks/share';

export type TrackingContext = 'petition_show_image' | 'petition_show_sign_cta_sticky' | 'petition_show_sign_cta_inline';

export function useGetTrackingData(
	petitionUserId: { id: string },
	currentUserId: string | undefined,
	petitionId: string,
	trackingContext: TrackingContext,
) {
	const sourceLocation = useQueryParamValue('source_location');

	return useCallback(
		(_channel: ShareChannel) => ({
			view_context: trackingContext,
			own_petition: petitionUserId.id === currentUserId,
			context: trackingContext,
			petition_id: `petition_${petitionId}`,
			source_location: sourceLocation,
		}),
		[currentUserId, petitionId, petitionUserId, sourceLocation, trackingContext],
	);
}
